import { AxiosError } from 'axios';
import { ErrorInfo } from '../../api/model';
import ErrorComponent from '../atoms/ErrorComponent';
import OkModal from './OkModal';

interface Props {
  error: AxiosError<ErrorInfo> | null;
  onClickOk?: () => void | undefined;
  children?: React.ReactNode | undefined;
}

/**
 * エラーモーダル
 * @param param0
 * @returns
 */
function ErrorModal({ error, onClickOk, children }: Props) {
  return (
    <OkModal onClickOk={onClickOk}>
      {children}
      <ErrorComponent error={error} />
    </OkModal>
  );
}

ErrorModal.defaultProps = {
  children: undefined,
  onClickOk: undefined,
};

export default ErrorModal;
